import { Inject } from '@odinjs/odin';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { ModalService, PanelAPI, RadioGroupAPI, SelectableItem } from '@philips-internal/oswald-ui-components';
import { HttpService, } from '@philips-internal/oswald-ui-core/lib/services';
import Controller, { OnBeforeSubmit, OnCancel, OnClick, OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';

import BaseController from '../../BaseController';
import './modified-pain-behavioral-controller.css';
import { Endpoint } from '../../../constants/endpoints';
import { FragmentNames, ModifiedPainBehavioralAliases } from '../../../codegen';

@Controller({ fragment: FragmentNames.MODIFIED_PAIN_BEHAVIORAL })
class ModifiedPainBehavioralController extends BaseController {

  @Inject(ModifiedPainBehavioralAliases.REFERENCE_MODAL)
  panelLoaderModalApi!: PanelAPI;

  @Inject(ModifiedPainBehavioralAliases.FACE_EXPRESSION_RADIO_GROUP)
  faceExpressionRadioGroupApi!: RadioGroupAPI;

  @Inject(ModifiedPainBehavioralAliases.MOVIMENTS_RADIO_GROUP)
  movimentsRadioGroupApi!: RadioGroupAPI;

  @Inject(ModifiedPainBehavioralAliases.CRIES_RADIO_GROUP)
  criesRadioGroupApi!: RadioGroupAPI;

  @OnMount({target: ModifiedPainBehavioralAliases.FACE_EXPRESSION_RADIO_GROUP})
  onMountFaceExpressionForm(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.modifiedPainBehavioralRadioGroup(336441, radioGroup);
  }

  @OnMount({target: ModifiedPainBehavioralAliases.MOVIMENTS_RADIO_GROUP})
  onMountMovimentsForm(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.modifiedPainBehavioralRadioGroup(336443, radioGroup);
  }

  @OnMount({target: ModifiedPainBehavioralAliases.CRIES_RADIO_GROUP})
  onMountCriesForm(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.modifiedPainBehavioralRadioGroup(336637, radioGroup);
  }

  @OnClose({ target: ModifiedPainBehavioralAliases.MODAL_PAIN_SCALE_REFERENCE})
  onCloseModal(): void {
    this.panelLoaderModalApi.setVisible(false);
  }

  @OnClick({ target: ModifiedPainBehavioralAliases.REFERENCE_LINK})
  onClickReference(): void {
    this.panelLoaderModalApi.setVisible(true);
  }

  @OnCancel({ target: ModifiedPainBehavioralAliases.CRIES_FORM})
  onClickCancel(): void {
    ModalService.close('modified-pain-behavioral');
  }

  @OnBeforeSubmit({ target: ModifiedPainBehavioralAliases.CRIES_FORM})
  onBeforeSubmitForm(): void {
    const setPainScaleValue = this.context.get('setPainScaleValue');
    setPainScaleValue(Number(this.faceExpressionRadioGroupApi?.getValue()?.value)
                      + Number(this.movimentsRadioGroupApi?.getValue()?.value)
                      + Number(this.criesRadioGroupApi?.getValue()?.value));

    ModalService.close('modified-pain-behavioral');
  }

  modifiedPainBehavioralRadioGroup(expressionId:number, radioGroup:RadioGroupAPI) :void{
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();

    HttpService.get(Endpoint.GET_PAIN_SCALE_DATA, {encounterId, expressionId, patientId})
      .then(response => {
        if(response) {
          const responseBody = response.body as SelectableItem[];
          radioGroup.setData(responseBody);
          radioGroup.setValue(responseBody[0]);
        }
      });
  }
}
export default ModifiedPainBehavioralController;
